<template>
  <div id="Header">
    <a href="/zscx">
      <!-- <img src="/img/logo.17eaed27.png"
           alt="全国职业技能入库查询系统"> -->
      <h2>全国职业技能入库查询系统</h2>
    </a>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
#Header {
  color: #2e7d32;
  border-bottom: 3px #2e7d32 solid;
  line-height: 38px;
  padding-top: 20px;
}
</style>
